import { createDPS } from '@lib/web3/contracts/DPS';
import createContractHook from '@lib/web3/hooks/contracts/createContractHook';

const useDPS = createContractHook(createDPS);
export default useDPS;
